module.exports = __webpack_public_path__ + "chromosom17_Genotyping.png?387a6acf3331ee14a3d840b4543560e0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chromosom17_Genotyping.png
// module id = 47
// module chunks = 0